// extracted by mini-css-extract-plugin
export default {"loader-position":"_10xl3db","loaderPosition":"_10xl3db","loader-position-grey":"_wlh09p","loaderPositionGrey":"_wlh09p"};